import { Component } from '@angular/core';
import { environment } from '@environment/environment';

@Component({
    selector: 'app-disconnected',
    templateUrl: './disconnected.component.html',
    styleUrls: ['./disconnected.component.scss']
})
export class AppDisconnectedComponent {

    goToLogin(go) {
        window.location.href = environment.loginBaseUri + '?authReason=disconnected&href='+window.location.href;
    }

}
